module.exports = __webpack_public_path__ + "static/media/portal-enter.2d1c8029.svg";